import React from 'react';
import { SocialIcon } from 'react-social-icons';
import { useTheme } from 'app/providers/ThemeContext';
import {
  BottomRow,
  Box,
  Brand,
  Column,
  ContactButton,
  Container,
  Description,
  Eyebrow,
  FooterLink,
  Heading,
  IntroRow,
  LinkList,
  Row,
  SocialLinks,
} from './FooterStyles.js';

const siteLinks = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/blog', label: 'Blog' },
  { href: '/ham-radio-learning', label: 'Ham Radio' },
];

const projectLinks = [
  { href: 'https://emmascourtgarden.com/', label: "Emma's Court Garden" },
  { href: 'https://www.fordhamsds.org/', label: 'Fordham SDS' },
  { href: 'https://www.glaciallakealbany.com/', label: 'Glacial Lake Albany' },
];

const socialLinks = [
  { network: 'facebook', url: 'https://www.facebook.com/brahm.schultz', label: 'Facebook' },
  { network: 'instagram', url: 'https://www.instagram.com/elbrahmo/?hl=en', label: 'Instagram' },
  {
    network: 'linkedin',
    url: 'https://www.linkedin.com/in/abraham-schultz-15099044/',
    label: 'LinkedIn',
  },
  { network: 'github', url: 'https://github.com/Agent215', label: 'GitHub' },
];

const Footer = () => {
  const { isDarkMode } = useTheme();
  const currentYear = new Date().getFullYear();
  const iconColor = isDarkMode ? '#effff4' : '#24382b';

  return (
    <Box $isDarkMode={isDarkMode}>
      <Container>
        <IntroRow>
          <div>
            <Eyebrow>Thanks for stopping by</Eyebrow>
            <Brand>Brahm Schultz</Brand>
            <Description>
              Software projects, radio experiments, field notes, and the occasional useful rabbit hole.
            </Description>
          </div>
          <ContactButton href="/contact-form">
            <span>Get in touch</span>
            <span aria-hidden="true">&rarr;</span>
          </ContactButton>
        </IntroRow>

        <Row>
          <Column>
            <Heading>Explore</Heading>
            <LinkList aria-label="Footer navigation">
              {siteLinks.map((link) => (
                <FooterLink key={link.href} href={link.href}>
                  {link.label}
                </FooterLink>
              ))}
            </LinkList>

            <Heading style={{ marginTop: '2rem' }}>More projects</Heading>
            <LinkList aria-label="More projects">
              {projectLinks.map((link) => (
                <FooterLink
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.label}
                </FooterLink>
              ))}
            </LinkList>
          </Column>

          <Column>
            <Heading>Elsewhere</Heading>
            <SocialLinks>
              {socialLinks.map((link) => (
                <SocialIcon
                  key={link.network}
                  className="social-icon"
                  network={link.network}
                  url={link.url}
                  bgColor="transparent"
                  fgColor={iconColor}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                />
              ))}
            </SocialLinks>
          </Column>
        </Row>

        <BottomRow>
          <p>&copy; {currentYear} Brahm Schultz. All rights reserved.</p>
          <p>Built with curiosity in Philadelphia.</p>
        </BottomRow>
      </Container>
    </Box>
  );
};

export default Footer;
